module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Multi Scrollers"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "my_scroller_1",
    staticStyle: {
      "top": "44px"
    },
    attrs: {
      "width": "50%",
      "on-refresh": _vm.refresh
    }
  }, _vm._l((_vm.items1), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  })), _vm._v(" "), _c('scroller', {
    ref: "my_scroller_2",
    staticStyle: {
      "left": "50%",
      "top": "44px"
    },
    attrs: {
      "width": "50%",
      "on-refresh": _vm.refresh2
    }
  }, _vm._l((_vm.items2), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 1
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7c7e246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/MultiScrollers.vue
// module id = 51
// module chunks = 0